<template>
  <div class="chain-icon" :class="`chain-icon--${chain}`">
    <img
      v-if="chainLogoUrl"
      :src="chainLogoUrl"
      :alt="chain"
      class="chain-icon__image"
      @error="handleImageError"
    />
    <div v-else class="chain-icon__fallback">
      <span class="chain-icon__letter">{{ fallbackLetter }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

interface Props {
  chain: string
}

const props = defineProps<Props>()

const imageError = ref(false)

const chainLogoUrls: Record<string, string> = {
  ethereum:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png',
  arbitrum:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/info/logo.png',
  base: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/base/info/logo.png',
  optimism:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/optimism/info/logo.png',
  solana:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/solana/info/logo.png',
}

const chainColors: Record<string, string> = {
  ethereum: '#627EEA',
  arbitrum: '#2D374B',
  base: '#0052FF',
  optimism: '#FF0420',
  solana: '#9945FF',
}

const chainLogoUrl = computed(() => {
  if (imageError.value) return null
  return chainLogoUrls[props.chain.toLowerCase()] ?? null
})

const fallbackColor = computed(() => {
  return chainColors[props.chain.toLowerCase()] ?? '#ccc'
})

const fallbackLetter = computed(() => {
  return props.chain.charAt(0).toUpperCase()
})

const handleImageError = () => {
  imageError.value = true
}
</script>

<style scoped>
.chain-icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chain-icon__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.chain-icon__fallback {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: v-bind(fallbackColor);
}

.chain-icon__letter {
  color: white;
  font-size: 50%;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
